import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-project-summary-clock",
  "data-qa": "countdown-clock"
}
const _hoisted_2 = { class: "gfu-project-summary-clock__head" }
const _hoisted_3 = { class: "gfu-project-summary-clock__title gfu-hd gfu-hd--h5" }
const _hoisted_4 = {
  key: 0,
  "data-qa": "project-overtime-text"
}
const _hoisted_5 = { class: "gfu-hd gfu-hd--h4 _tac _py-1 gfu-bt--caption" }
const _hoisted_6 = { class: "_tc--error" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_countdown_clock = _resolveComponent("countdown-clock")
  const _component_base_divider = _resolveComponent("base-divider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", _hoisted_3, _toDisplayString($props.title), 1 /* TEXT */)
    ]),
    _createVNode(_component_countdown_clock, {
      timestamp: $props.targetDate,
      "elapsed-message": $props.elapsedMessage,
      class: "_mx-a",
      "pad-numbers": "",
      "data-qa": "countdown-clock"
    }, null, 8 /* PROPS */, ["timestamp", "elapsed-message"]),
    ($options.isEndgameTextVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_base_divider, { class: "_my-0" }),
          _createElementVNode("h4", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString($options.endgameText), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}